import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroSection from './components/HeroSection';
import FeaturedSection from './components/FeaturedSection';
import CategorySection from './components/CategorySection';
import LatestSection from './components/LatestSection';
import StatsBanner from './components/StatsBanner';

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <Navbar />

      <main>
        <HeroSection />
        <FeaturedSection />
        <CategorySection />
        <LatestSection />
        <StatsBanner />
      </main>

      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebSite',
            name: '土豪漫画网',
            alternateName: '土豪漫画',
            url: 'https://tuhaomanhua.com/',
            description:
              '土豪漫画网提供海量韩漫、日漫、国漫分类浏览，热门漫画一应俱全。全部免费在线阅读，下拉式流畅体验。',
            potentialAction: {
              '@type': 'SearchAction',
              target: 'https://tuhaomanhua.com/search?q={search_term_string}',
              'query-input': 'required name=search_term_string',
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Organization',
            name: '土豪漫画网',
            url: 'https://tuhaomanhua.com/',
            description:
              '土豪漫画网 —— 海量韩漫、日漫、国漫分类大全，热门漫画免费在线阅读平台。',
            contactPoint: {
              '@type': 'ContactPoint',
              email: 'contact@tuhaomanhua.com',
              contactType: 'customer service',
            },
          }),
        }}
      />
    </>
  );
}